import { SelectProps as SelectPropsMui } from '@mui/material';
import { ElementType } from 'react';
import { StyledMenuItem } from '../Field/Field.styles';
import { StyledSelect } from './ListSelect.styles';

export type SelectProps = SelectPropsMui & {
  readonly iconComponent: ElementType;
  readonly options: { key: string; value: string }[];
};

export function ListSelect({
  onChange,
  iconComponent,
  value,
  options,
  ...rest
}: SelectProps) {
  return (
    <StyledSelect
      IconComponent={iconComponent}
      inputProps={{ 'aria-label': 'List Select' }}
      onChange={onChange}
      value={value}
      {...rest}
    >
      {options.map((option) => (
        <StyledMenuItem key={option.key} value={option.key}>
          {option.value}
        </StyledMenuItem>
      ))}
    </StyledSelect>
  );
}
